import axios from 'axios'

import { apiUrl } from '@/config'

const state = {
  code: null,
  participant: {
    id: null
  },
}

const getters = {}

const mutations = {
  setParticipant (state, participant) {
    if (participant) {
      state.participant = {
        name: participant[0].participant.name,
        id: participant[0].participant.id,
        wishlist: participant[0].participant.wishlist,
        draws: participant.map(p => ({ participant: p.drawn, special: p.special }))
      }
    } else {
      state.participant = {
        id: null
      }
    }
  },
  setCode (state, code) {
    state.code = code;
  }
}

const actions = {
  getParticipant (context, eventId) {
    if (context.state.code == null) {
      return context.commit('setParticipant', null);
    }
    return axios.get(`${apiUrl}/api/events/${eventId}/draws/${context.state.code}`)
      .then(response => { context.commit('setParticipant', response.data); })
      .catch(e => { console.log(e) })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
